export default "__VITE_ASSET__DhkWlPWV__"